// Online Team Store Management App Index
// Routes to the appropriate Team Store Management page based on the URL

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import StoreEditor from './StoreEditor';
import Reports from './Reports';

const TeamStoreManagementApp = () => {
  return (
    <Routes>
      {/* Main dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="team-stores:read" requiredRole="admin">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Store editor */}
      <Route
        path="/edit/:storeId"
        element={
          <ProtectedRoute requiredPermission="team-stores:read" requiredRole="admin">
            <StoreEditor />
          </ProtectedRoute>
        }
      />

      {/* Reports */}
      <Route
        path="/reports"
        element={
          <ProtectedRoute requiredPermission="team-stores:read" requiredRole="admin">
            <Reports />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/team-store-management" replace />} />
    </Routes>
  );
};

export default TeamStoreManagementApp;
